import { createApp } from '@app/adapters/create-app'

import OverviewNavigationDrawer from '@app/application/workflow-overview-navigation/components/overview-navigation-drawer.vue'
import { invalidateRecentTemplatesCache } from '@app/application/workflow-overview-navigation/api'

// Invalidate the recent templates cache whenever the user navigates away from a
// template page, so the next overview load reflects the visit just recorded by
// save_or_update_user_template_visit.
document.addEventListener('turbolinks:before-visit', () => {
  if (
    /(\/reconciliation_texts\/|\/account_entry\/)/.test(
      window.location.pathname
    )
  ) {
    invalidateRecentTemplatesCache()
  }
})

window.onDomLoad(function ($dom) {
  $dom
    .find("[data-behaviour='left-sidepanel-overview-navigation']")
    .each(function () {
      const {
        allowedFilterValues,
        defaultFilterParamValue,
        highlightedId,
        highlightedType,
        ledgerId,
        userType,
        dependsOnReviewStore,
        workflowId,
        messageBusChannel,
        messageBusLastId,
        showWorkflowTree,
        ctrlClick,
      } = this.dataset

      createApp(OverviewNavigationDrawer, {
        allowedFilterValues: allowedFilterValues
          ? JSON.parse(allowedFilterValues)
          : undefined,
        defaultFilterParamValue,
        dependsOnReviewStore: dependsOnReviewStore === 'true',
        highlightedId: highlightedId ? parseInt(highlightedId, 10) : null,
        highlightedType: highlightedType,
        ledgerId: ledgerId ? parseInt(ledgerId, 10) : null,
        workflowId: workflowId ? parseInt(workflowId, 10) : null,
        userType,
        messageBusChannel,
        messageBusLastId: messageBusLastId
          ? parseInt(messageBusLastId, 10)
          : -1,
        showWorkflowTree: showWorkflowTree ? showWorkflowTree === 'true' : true,
        ctrlClick: ctrlClick !== 'false',
      }).mount(this)
    })
})
